/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Allow_Orphan_WordsInputs */

const en_allow_orphan_words = /** @type {(inputs: Allow_Orphan_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allow Orphan Words`)
};

const fr_allow_orphan_words = /** @type {(inputs: Allow_Orphan_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autoriser les mots orphelins`)
};

const de_allow_orphan_words = /** @type {(inputs: Allow_Orphan_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zulassen von verwaisten Wörtern`)
};

const it_allow_orphan_words = /** @type {(inputs: Allow_Orphan_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consenti parole orfane`)
};

const ru_allow_orphan_words = /** @type {(inputs: Allow_Orphan_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разрешить использование слов-сирот`)
};

const es_allow_orphan_words = /** @type {(inputs: Allow_Orphan_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permitir palabras huérfanas`)
};

const zh_cn2_allow_orphan_words = /** @type {(inputs: Allow_Orphan_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`允许孤立词`)
};

const ja_allow_orphan_words = /** @type {(inputs: Allow_Orphan_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`孤立語を許可する`)
};

const hi_allow_orphan_words = /** @type {(inputs: Allow_Orphan_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनाथ शब्दों की अनुमति दें`)
};

const pt_pt2_allow_orphan_words = /** @type {(inputs: Allow_Orphan_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permitir palavras órfãs`)
};

/**
* | output |
* | --- |
* | "Allow Orphan Words" |
*
* @param {Allow_Orphan_WordsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const allow_orphan_words = /** @type {((inputs?: Allow_Orphan_WordsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Allow_Orphan_WordsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_allow_orphan_words(inputs)
	if (locale === "de") return de_allow_orphan_words(inputs)
	if (locale === "it") return it_allow_orphan_words(inputs)
	if (locale === "ru") return ru_allow_orphan_words(inputs)
	if (locale === "es") return es_allow_orphan_words(inputs)
	if (locale === "zh-CN") return zh_cn2_allow_orphan_words(inputs)
	if (locale === "ja") return ja_allow_orphan_words(inputs)
	if (locale === "hi") return hi_allow_orphan_words(inputs)
	if (locale === "pt-PT") return pt_pt2_allow_orphan_words(inputs)
	return en_allow_orphan_words(inputs)
});